import { Skeleton } from '@/_components';

export function LoaderRows({ columnCount, rowCount = 3 }: { columnCount: number; rowCount?: number }) {
  return (
    <tfoot>
      {Array.from({ length: rowCount }, (_, i) => (
        <tr key={i} className="border-c-border-muted border-b">
          {Array.from({ length: columnCount }, (_, j) => (
            <td key={j} className="px-2 py-2 align-middle">
              <Skeleton className="h-5 w-full" />
            </td>
          ))}
        </tr>
      ))}
    </tfoot>
  );
}
